import React from 'react';

import { useIntl } from 'react-intl';

import Button from '@atlaskit/button/new';
import ModalBody from '@atlaskit/modal-dialog/modal-body';
import Modal from '@atlaskit/modal-dialog/modal-dialog';
import ModalFooter from '@atlaskit/modal-dialog/modal-footer';
import ModalHeader from '@atlaskit/modal-dialog/modal-header';
import ModalTitle from '@atlaskit/modal-dialog/modal-title';
import ModalTransition from '@atlaskit/modal-dialog/modal-transition';

import messages from './messages';

interface UnpinConfirmModalProps {
	isOpen: boolean;
	onClose: () => void;
	onConfirm: () => void;
}

/** Confirms unpinning before it happens — unpinning is reversible, but immediate and easy to
 * trigger by mistake from a hover-revealed action, so this guards against an accidental click. */
export const UnpinConfirmModal = ({
	isOpen,
	onClose,
	onConfirm,
}: UnpinConfirmModalProps): React.JSX.Element => {
	const { formatMessage } = useIntl();

	return (
		<ModalTransition>
			{isOpen && (
				<Modal onClose={onClose} width="small" testId="rovo-for-you-unpin-confirm-modal">
					<ModalHeader hasCloseButton>
						<ModalTitle>{formatMessage(messages.unpinConfirmModalTitle)}</ModalTitle>
					</ModalHeader>
					<ModalBody>{formatMessage(messages.unpinConfirmModalBody)}</ModalBody>
					<ModalFooter>
						<Button
							appearance="subtle"
							onClick={onClose}
							testId="rovo-for-you-unpin-confirm-modal-cancel-button"
						>
							{formatMessage(messages.unpinConfirmModalCancelLabel)}
						</Button>
						<Button
							appearance="primary"
							onClick={onConfirm}
							testId="rovo-for-you-unpin-confirm-modal-confirm-button"
						>
							{formatMessage(messages.unpinConfirmModalConfirmLabel)}
						</Button>
					</ModalFooter>
				</Modal>
			)}
		</ModalTransition>
	);
};
